import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/jobtoken/logo-onboarding.png")